// extracted by mini-css-extract-plugin
export default {"wrapper":"n52fK","input":"A37UL","searchIconWrap":"dtlqB","searchIcon":"DeG7V","clearIconWrap":"dV0xz","clearIcon":"JM6ng"};